export default "__VITE_ASSET__BuYECBxV__"